export const formatNumber = (value: any) => Number(value || 0).toLocaleString();

export const formatMoney = (value: any) => {
  const n = Number(value || 0);
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000_000) return `${(n / 1_000_000_000_000).toFixed(2)} T`;
  if (abs >= 1_000_000_000) return `${(n / 1_000_000_000).toFixed(2)} B`;
  if (abs >= 1_000_000) return `${(n / 1_000_000).toFixed(2)} M`;
  return n.toLocaleString();
};

export const decisionColor = (decision?: string): 'default' | 'success' | 'warning' | 'error' | 'info' => {
  switch ((decision || '').toUpperCase()) {
    case 'APPROVED': return 'success';
    case 'REDUCED': return 'warning';
    case 'REJECTED': return 'error';
    case 'ESCALATED': return 'info';
    case 'HOLD': return 'warning';
    default: return 'default';
  }
};

export const scoreLabel = (score: any) => {
  const n = Number(score || 0);
  if (n >= 80) return 'Excellent';
  if (n >= 60) return 'Good';
  if (n >= 40) return 'Moderate';
  return 'Low';
};
